import moment from 'moment';
import { toast } from 'react-toastify';


const convertingDate = (data, type, format) => {
  if (type === 'last_login') {
    return moment(data[type]).format(format);
  }
  if (type === 'created_at' || type === 'last_replay_at') {
    return moment(data[type]).format(format);
  }
  return data[type] ? data[type] : 'None';
};

const getCellValueByType = (column, item, service) => {
  const value = convertingDate(item, column.name, 'll');
  if (column.name) {
    if (typeof column.value === 'function') return column.value({ column, value, service });
    // need to be modified
    if (typeof item[column.name] === 'undefined' && !value) return 'None';
    return value;
  }
  return undefined;
};


const prepareData = checked => Object.keys(checked)
  .filter(key => (parseInt(key, 10) === -1 ? false : checked[key] !== false))
  .map(key => parseInt(key, 10));

const onRemoveCallback = service => props => async (e) => {
  const { currentUser, setUpdated, setChecked, setShowConfirm, setCurrentUser, currentCustomer, setCurrentCustomer, setIsLoading } = props;
  const formData = prepareData(props.checked);
  if (formData.length) {
    setShowConfirm(false);
    const deleteSuccess = await service.destroyAllByIds(formData);
    setUpdated({ removed: deleteSuccess });
    setChecked({});
    if (deleteSuccess.length) {
      toast.success(props.t('Users removed'));
      if (currentUser && formData.includes(currentUser.id)) {
        setCurrentUser(null);
      } else if (currentCustomer && formData.includes(currentCustomer.id)) {
        setCurrentCustomer(null);
      }
    } else { toast.error(props.t('Something went wrong')); }
  }
};

const changeStatus = service => props => async (e, status) => {
  e.preventDefault();
  const { currentUser, setUpdated, setChecked, setShowConfirm, setCurrentUser, currentCustomer, setCurrentCustomer } = props;
  const formData = prepareData(props.checked);
  let updateSuccess = false;
  if (formData.length) {
    toast.success(props.t('Your changes has been sent! Please wait!'));
    await service.changeStatus(formData, status);
    updateSuccess = true;
    if (updateSuccess) {
      setUpdated({ id: formData[0] });
      setChecked({});
      setShowConfirm(false);
      toast.success(props.t('Status changed'));
      if (currentUser && formData.includes(currentUser.id)) {
        if (!status || (parseInt(currentUser.status, 10) !== service.STATUS_PENDING && status)) {
          setCurrentUser({ ...currentUser, status });
        }
      } else if (currentCustomer && formData.includes(currentCustomer.id)) {
        if (!status || (parseInt(currentCustomer.status, 10) !== service.STATUS_PENDING && status)) {
          setCurrentCustomer({ ...currentCustomer, status });
        }
      }
    }
  }
};

const resentInvite = service => props => async (e) => {
  e.preventDefault();
  const { setUpdated, setChecked, setShowConfirm } = props;
  const formData = prepareData(props.checked);
  let updateSuccess = false;
  if (formData.length) {
    toast.success(props.t('Your invites has been sent! Please wait!'));
    await service.resendInvite(formData);
    updateSuccess = true;
    if (updateSuccess) {
      setUpdated({ id: formData[0] });
      setChecked({});
      setShowConfirm(false);
      toast.success(props.t('Invites sent'));
    }
  }
};

const afterImport = props => (status) => {
  const { t, setUpdated } = props;
  if (!status)toast.error(t('Something went wrong!'));
  else {
    toast.success(t('New users were invited'));
    setUpdated({ invited: true });
  }
};

export default {
  getCellValueByType,
  convertingDate,
  prepareData,
  changeStatus,
  onRemoveCallback,
  resentInvite,
  afterImport};



// WEBPACK FOOTER //
// ./src/helpers/currentUser.helper.js